


<template>
    <div>
        <p class="surveys-common-label pb-0 mb-1" >
            {{`${label} ${asterisk ? '*' : ''}`}}
            <span v-if="sublabel" class="surveys-common-sublabel"><br> {{sublabel}}</span>
        </p>
        <!-- ocultar el text form e intentar mostrar el error del toggle usando al text field -->
        <v-text-field
            class="d-none"
            v-model="value" 
            :rules="rule"
            ></v-text-field>
        <v-btn-toggle
            
            v-model="value"
            borderless
            dense
            class="toggle-option-survey-toggle"
            active-class="primary"
            :rules="rule"
        >
            <v-row justify="center">
                <v-col :class="`pl-3 pr-1 ${index == 0 ? 'pl-3 pr-1' : index -1 == items.length ? 'pl-1 pr-3' : 'px-1'}`"  v-for="(item, index) in items" :key="index" >
                    <v-btn :value="item.value" :class="`${readonly ? 'toggle-option-survey-disabled-click' :''}`" block  depressed small>
                        <span class="">{{item.text}}</span>
                    </v-btn>
                </v-col>
            </v-row>
        </v-btn-toggle>
        <p class="pb-0 error--text caption mb-0 text-left" v-if="errorMessage"> {{errorMessage}} </p>
    </div>

</template>
<script>
export default {
    props: ['valueInput', 'label', 'items', 'errorMessage', 'readonly', 'asterisk', 'rule', 'sublabel'],
    model: {
        prop: 'value',
        event: 'valueChange'
    },
    computed: {
        value: {
            get: function() {
                return this.valueInput
            },
            set: function(value) {
                this.$emit('valueChange', value)
            }
        },
    },
    watch: {
        
    },
    data(){
        return{
            autofillFix:false
        }
    },
    mounted(){
    },

    methods:{
        

    }
}
</script>

<style lang="scss">
    .toggle-option-survey{
        &-toggle{
            width: -webkit-fill-available;

            
        }

        &-label{
            font-size: .83rem;
            line-height: normal;
        }

        &-sublabel{
            font-style: italic;
            font-size: 0.73rem;
            color: #707070;
        }

        &-disabled-click { pointer-events: none } 
    }

   
</style>